<template>
    <ModalFormCard :action="action" class="modal-default wide" v-bind="{ errors, saving }">
        <template #title>{{ isEdit ? 'Edit' : 'New' }} SMS message</template>

        <Select
            v-model:value="value.number"
            :options="numberOptions"
            groupClass="bg-white text-15"
            label="Select phone number"
            name="number"
            placeholder="Select number"
        >
            <template #option="{ option, selected }">
                {{ option.html }}
                <!-- {{ $help.e164ToNumber(option.value) }}
                {{ parseInt(option.id) == primaryPhoneId && !selected ? ' - PRIMARY' : '' }} -->
            </template>
        </Select>

        <input type="hidden" name='user_id' :value='numberOptions.find(n => n.value == value.number)?.id' />

        <Textarea
            v-model:value="value.description"
            limit="1600"
            :disabled="saving"
            class="transition-all duration-500 ease-in-out mt-4"
            label="SMS message"
            name="description"
            placeholder="Start typing…"
            rows="6"
        >
            <template #limit="{ value, length, limit }"
                >{{ length }} / 160
                <template v-if="length < limit"
                    >({{ Math.ceil(length / 160) }} {{ $help.pluralize('message', Math.ceil(length / 160)) }})</template
                >
                <template v-else>(1,600 characters max, remove characters)</template>
            </template>
        </Textarea>

        <div class="grid grid-cols-1 gap-3 mt-4" v-if="_options?.deals">
            <CanHaveDeal :contactId="contactId" :modelId="modelId" :modelType="modelType" :deals="_options?.deals" />
        </div>

        <template v-else>
            <input type="hidden" :value="contactId" name="belongs_id" />
            <!-- <input type="hidden" :value="103" name="belongs_type" /> -->
            <input type="hidden" :value="options.modelType || modelType" name="belongs_type" />
        </template>

        <div class="grid grid-cols-2 lg:grid-cols-4 pt-8 gap-3">
            <ButtonSaving :disabled="saving" class="button-black h-12 col-span-2" name="published_at" value="1"> Send SMS </ButtonSaving>

            <button
                v-if="editingModel == null || editingModel.published_at == null"
                :disabled="saving"
                :value="null"
                class="button-purple h-12 col-span-2 lg:col-span-1"
                name="published_at"
            >
                Save draft
            </button>
        </div>
    </ModalFormCard>
</template>

<script>
import SMS from '~/models/sms.js'
import Modal from '~/mixins/modal.js'
import CanHaveDeal from '~/components/customer/blocks/can-have-deal.vue'

export default {
    mixins: [Modal],

    created() {
        this.requiresCRMFunds()

        this.setup(SMS)

        if (this.value.number == null) {
            this.value.number = this.numberOptions[0].value
        }

        if (this.options.selectedValueId != null) {
            this.value.number = this.numberOptions.find((n) => n.id == this.options.selectedValueId).value
        }
    },

    computed: {
        numberOptions() {
            if (this.modelType == 2) {
                let model = this.options.model != null ? this.options.model : this._options.model;
                let options = [];

                for (let u in model.users) {
                    for (let i in [1,2,3]) {
                        if (model.users[u]['contact_number_'+i] != null && model.users[u]['contact_number_'+i] != '') {
                            let user = model.users[u]
                            let html = user.fullName() + ' - ';

                            if (user.job_title != null) {
                                html += user.job_title + ' - ';
                            }

                            options.push({
                                html: html + this.$help.e164ToNumber(user['contact_number_'+i]),
                                value: user['contact_number_'+i],
                                id: user.id
                            });
                        }
                    }
                }

                return options;
            }
            // console.log('this._options.model', this.options)
            return this._options.communications
                .filter((c) => c.type == 0)
                .map((n) => {
                    return {
                        html: this.$help.e164ToNumber(n.value), // + (n.id == this.options.model.primary_phone ? ' - PRIMARY' : ''),
                        value: n.value,
                        id: n.id,
                    }
                })
        },

        contactId() {
            if (this.contactIdSearch != null) {
                return this.contactIdSearch
            }

            if (this.editingModel != null && parseInt(this.editingModel.belongs_type) == 103) {
                // console.log(this.editingModel)
                return this.editingModel.belongs.contact_id
            }

            return this.editingModel?.belongs_id || this.modelId
        },

        primaryPhoneId() {
            if (this.modelType == 2) {
                return this.options.model.user.id
            }

            return this._options.model.primary_phone;
        }
    },

    components: {
        CanHaveDeal,
    },
}
</script>
